module.exports = __webpack_public_path__ + "fonts/righthand-lightitalic-personal.3a57a0ef.ttf";